import React, { useContext } from "react";
import { FormattedMessage } from "react-intl";
import { Button, Modal } from "reactstrap";
import { AppContext } from "services/appContext/AppContext";

type Props = {
  // showLoadingIndicator?: boolean;
  onSubmit: () => void;
};

export default function TimerCompleteModal(props: Props) {
  const { appContext } = useContext(AppContext);
  const theme = appContext.theme;
  
  return (
    <>
      <Modal className="modal-dialog-centered modal-sm" isOpen={true}>
        <div className="modal-header pb-0">
          <h6 className="modal-title">
            <FormattedMessage id="general.timeOut" />
          </h6>
        </div>
        <div className="modal-body pb-0">
          <div>
            <FormattedMessage id="general.timeOut.message"></FormattedMessage>
          </div>
        </div>
        <div className="modal-footer">
          <Button
            color="primary"
            type="submit"
            className={`ml-auto ${theme === "light" ? "bg-lblue no-border" : ""}`}
            onClick={props.onSubmit}>
            {/* {props.showLoadingIndicator && <i className="fas fa-spinner fa-spin mr-2" />} */}
            <FormattedMessage id="confirmationModal.confirmButton" />
          </Button>
        </div>
      </Modal>
    </>
  );
}
